// extracted by mini-css-extract-plugin
export default {"textEl":"TextBlock_textEl__xYgtV","textBl":"TextBlock_textBl__UG9si"};